// The api sends calendar dates as "YYYY-MM-DD" (São Paulo). new Date() would
// read them as UTC midnight and show the previous day in Brazil, so they are
// formatted from the string itself.
export const formatDayMonth = (isoDate) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(isoDate ?? "")
  if (!match) return ""
  return `${match[3]}/${match[2]}`
}

// Same as formatDayMonth with the year: "27/11/2027".
export const formatDate = (isoDate) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(isoDate ?? "")
  if (!match) return ""
  return `${match[3]}/${match[2]}/${match[1]}`
}

export const pluralDays = (n) => `${n} ${n === 1 ? "dia" : "dias"}`

const SAO_PAULO_DAY_MONTH = new Intl.DateTimeFormat("pt-BR", {
  day: "2-digit",
  month: "2-digit",
  timeZone: "America/Sao_Paulo",
})

// Instants from the api (RFC 3339, e.g. current_period_end) shown as the
// São Paulo calendar day.
export const formatInstantDayMonth = (iso) => {
  const t = Date.parse(iso ?? "")
  if (Number.isNaN(t)) return ""
  return SAO_PAULO_DAY_MONTH.format(new Date(t))
}

const SAO_PAULO_DATE = new Intl.DateTimeFormat("pt-BR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  timeZone: "America/Sao_Paulo",
})

export const formatInstantDate = (iso) => {
  const t = Date.parse(iso ?? "")
  if (Number.isNaN(t)) return ""
  return SAO_PAULO_DATE.format(new Date(t))
}

const SAO_PAULO_PARTS = new Intl.DateTimeFormat("en-CA", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  timeZone: "America/Sao_Paulo",
})

// Today + n days on the São Paulo calendar, as "YYYY-MM-DD" (the first
// charge date of a trial shown on /plan, api D84).
export const addDaysToToday = (n, now = new Date()) => {
  const parts = Object.fromEntries(SAO_PAULO_PARTS.formatToParts(now).map((p) => [p.type, p.value]))
  const day = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day) + n))
  return day.toISOString().slice(0, 10)
}
